import { useState, useEffect } from 'react'
import CaritraWidgetApi from '../../api';
import CaritraWidgetLoader from '../Loader/Loader';
import PrivateWidgetHandler from '../Widget/PrivateWidgetHandler';
import Widget from '../Widget/Widget';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import './WidgetWrapper.css'
const generateTheme = (widgetColor) => {
  return createMuiTheme({
    palette: {
      primary: {
        main: widgetColor.buttonColor
      },
      secondary: {
        main: widgetColor.buttonTextColor
      }
    },
    typography: {
      "fontFamily": `"Rubik", sans-serif`,
      allVariants: {
        color: widgetColor.textColor
      },
    },
    overrides: {
      "MuiPickersDay": {
        day: {
          color: widgetColor.textColor
        },
        daySelected: {
          color: widgetColor.buttonTextColor
        }
      }
    }
  })
}

function CaritraWidgetWrapper() {

  const [widgetInfo, setwidgetInfo] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    processwidgetInfo()
  }, [])

  const processwidgetInfo = async () => {
    let data = await getwidgetInfo()
    if (data.error) {
      setError(data.errorMessage)
    }
    else if (data.widgetInfo) {
      setwidgetInfo(data.widgetInfo)
    }
    else {
      setError("Widget info could not be retrieved")
    }
  }

  if (error) {
    return (null)
  }
  else if (widgetInfo === null) {
    return <CaritraWidgetLoader />
  }
  else if (widgetInfo.widgetView === "Private") {
    return (
      <ThemeProvider theme={generateTheme(widgetInfo.widgetColor)}>
        <div className = "WidgetWrapper">
          <PrivateWidgetHandler
            {...{ setError, widgetInfo }}
          />
        </div>
      </ThemeProvider>
    )
  }
  else if (widgetInfo.widgetView === "Group") {
    return (
      <ThemeProvider theme={generateTheme(widgetInfo.widgetColor)}>
        <div className = "WidgetWrapper">
          <Widget
            {...{ setError, widgetInfo }}
          />
        </div>
      </ThemeProvider>
    )
  }
  else {
    setError("Invalid widget data loaded")
    return null
  }
}

const getwidgetInfo = async () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  if (!params.widgetId) {
    return { error: true, errorMessage: "Widget ID not provided" }
  }
  else {
    return await CaritraWidgetApi.post('/api/external/widget/info', { widgetId: params.widgetId })
  }
}



export default CaritraWidgetWrapper;
